const cloneDeep = function (o) {
  return JSON.parse(JSON.stringify(o))
}

const isFunction = function (o) {
  return o && ({}).toString.call(o) === '[object Function]'
}

const map = function (collection, map) {
  return Object.keys(collection).map(key => map(collection[key], key))
}

const zipObject = function (props, values) {
  let index = -1
  const length = props.length
  const valsLength = values.length
  const result = {}

  while (++index < length) {
    const value = index < valsLength ? values[index] : undefined
    result[props[index]] = value
  }
  return result
}

export const withDefaults = function (collection, defaultValue) {
  const r = zipObject(
    collection,
    map(
      collection,
      () =>
        isFunction(defaultValue)
          ? defaultValue
          : cloneDeep(defaultValue)
    )
  )
  return r
}
